import { render } from "./AIAssistant.vue?vue&type=template&id=a809da6e&scoped=true"
import script from "./AIAssistant.vue?vue&type=script&lang=js"
export * from "./AIAssistant.vue?vue&type=script&lang=js"

import "./AIAssistant.vue?vue&type=style&index=0&id=a809da6e&scoped=true&lang=css"
import "./AIAssistant.vue?vue&type=style&index=1&id=a809da6e&lang=scss"

import exportComponent from "/Users/sandhiyabaskar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a809da6e"]])

export default __exports__